import { render, staticRenderFns } from "./zuzhuanghetong.vue?vue&type=template&id=2d7d91db&scoped=true&"
import script from "./zuzhuanghetong.vue?vue&type=script&lang=js&"
export * from "./zuzhuanghetong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7d91db",
  null
  
)

export default component.exports